import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreClaimService } from '../../../services/preclaim.service';
import { SwalService } from '../../../../../common/services/swal.service';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreClaimRequest } from '../../../../../core/data/dtos/preclaim.request';
import { lastValueFrom } from 'rxjs';

export interface ValidationModalResponse {
  validated: boolean;
  claimReferenceNumber: string;
}

@Component({
    selector: 'app-validation-modal',
    imports: [FormsModule, ReactiveFormsModule],
    providers: [PreClaimService],
    templateUrl: './validation-modal.component.html',
    styleUrl: './validation-modal.component.css'
})
export class ValidationModalComponent {
  @ViewChild('modal') modal!: NgbModalRef;
  @Input({ required: true }) isPolicyOwner!: boolean;

  @Output() onCodeValidated = new EventEmitter<ValidationModalResponse>();
  code: string = '';
  claimReferenceNumber: string = '';
  request?: PreClaimRequest;

  timer: number = 0;
  intervalId: any;

  constructor(
    private preclaimService: PreClaimService,
    private swalService: SwalService,
    private modalService: NgbModal,
  ) {}

  get timerRunning() {
    return this.timer > 0;
  }

  async sendOTP(startTimer = true) {
    if (!this.request) return;

    this.swalService.showLoading();
    const result = await lastValueFrom(
      this.preclaimService.createPreClaim(this.request),
    );
    this.claimReferenceNumber = result.data;
    this.swalService.dismiss();
    if (startTimer) this.startTimer();
  }

  show = async (
    request: PreClaimRequest,
    skipOtpValidationForTesting = false,
  ) => {
    this.request = request;
    await this.sendOTP(!skipOtpValidationForTesting);
    if (skipOtpValidationForTesting) {
      this.onCodeValidated.emit({
        validated: true,
        claimReferenceNumber: this.claimReferenceNumber,
      });
      return;
    }
    this.modalService.open(this.modal, { size: 'lg' });
  };

  async validateCode() {
    if (!this.code) {
      this.swalService.notification('El código de validación es requerido');
      return;
    }

    try {
      await lastValueFrom(
        this.preclaimService.validateCode(this.code, this.claimReferenceNumber),
      );
      this.onCodeValidated.emit({
        validated: true,
        claimReferenceNumber: this.claimReferenceNumber,
      });
      this.modalService.dismissAll();
      clearInterval(this.intervalId);
    } catch (error) {
      console.log(error);
      this.swalService.notification('No se pudo validar el código');
    }
  }

  startTimer() {
    this.timer = 15;
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }
}
